// src/ui/controls/dropdown.ts

export interface DropdownOpts<T extends string> {
  label: string;
  value: T;
  options: { id: T; label: string }[];
  onChange: (id: T) => void;
}

export function createDropdown<T extends string>(o: DropdownOpts<T>): HTMLDivElement {
  const wrap = document.createElement('div');
  wrap.className = 'slider-row';
  wrap.style.display = 'block';
  const lab = document.createElement('label');
  lab.textContent = o.label;
  const sel = document.createElement('select');
  sel.style.width = '100%';
  for (const opt of o.options) {
    const el = document.createElement('option');
    el.value = opt.id; el.textContent = opt.label;
    sel.append(el);
  }
  sel.value = o.value;
  sel.addEventListener('change', () => o.onChange(sel.value as T));
  wrap.append(lab, sel);
  return wrap;
}
